import { Modal, Form, Input, Select, Radio, Button } from "antd";
import { useEffect } from "react";

interface Props {
    open: boolean;
    setOpen: (v: boolean) => void;
    onCreate: (values: any) => void;
    editingStock?: any;
}

export default function AddStockModal({
    open,
    setOpen,
    onCreate,
    editingStock,
}: Props) {

    const [form] = Form.useForm();

    const handleSubmit = () => {
        form.validateFields().then((values) => {
            onCreate(values);
            form.resetFields();
            setOpen(false);
        });
    };

    useEffect(() => {
        if (editingStock) {
            form.setFieldsValue(editingStock);
        } else {
            form.resetFields();
        }
    }, [editingStock, form]);

    return (
        <Modal
            open={open}
            title={editingStock ? "Chỉnh sửa chi nhánh" : "Thêm chi nhánh mới"}
            footer={null}
            onCancel={() => setOpen(false)}
            width={600}
            className="dark:[&_.ant-modal-content]:bg-[#1f1f1f]
                dark:[&_.ant-modal-header]:bg-[#1f1f1f]
                dark:[&_.ant-modal-close]:text-white
                dark:[&_.ant-modal-title]:text-white"
        >
            <Form
                form={form}
                layout="horizontal"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 18 }}
                className="mt-6"
            >

                <Form.Item
                    label="Tên"
                    name="name"
                    rules={[{ required: true }]}
                >
                    <Input className="t-input" />
                </Form.Item>

                <Form.Item
                    label="Số điện thoại"
                    name="phone"
                    rules={[{ required: true }]}
                >
                    <Input className="t-input" />
                </Form.Item>

                <Form.Item label="Email" name="email">
                    <Input className="t-input" />
                </Form.Item>

                <Form.Item
                    label="Tỉnh/Thành phố"
                    name="province"
                    rules={[{ required: true }]}
                >
                    <Select className="t-input" placeholder="Tỉnh/Thành phố">
                        <Select.Option value="Hồ Chí Minh">Hồ Chí Minh</Select.Option>
                        <Select.Option value="Hà Nội">Hà Nội</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Quận/Huyện"
                    name="district"
                    rules={[{ required: true }]}
                >
                    <Select className="t-input" placeholder="Quận/Huyện">
                        <Select.Option value="Quận 1">Quận 1</Select.Option>
                        <Select.Option value="Quận 5">Quận 5</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Phường/Xã"
                    name="ward"
                    rules={[{ required: true }]}
                >
                    <Select className="t-input" placeholder="Phường/Xã">
                        <Select.Option value="Phường 1">Phường 1</Select.Option>
                        <Select.Option value="Phường 2">Phường 2</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item label="Địa chỉ" name="address">
                    <Input className="t-input" />
                </Form.Item>

                <Form.Item label="Loại" name="type">
                    <Select className="t-input">
                        <Select.Option value="warehouse">Kho</Select.Option>
                        <Select.Option value="branch">Chi nhánh</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item label="Hiển thị" name="display">
                    <Radio.Group>
                        <Radio value={1}>Có</Radio>
                        <Radio value={0}>Không</Radio>
                    </Radio.Group>
                </Form.Item>

                <div className="flex gap-2 justify-center mt-4">
                    <Button
                        type="primary"
                        className="bg-[#3e91ab] border-[#3e91ab]"
                        onClick={handleSubmit}
                    >
                        {editingStock ? "Cập nhật" : "Tạo mới"}
                    </Button>

                    <Button onClick={() => setOpen(false)}>
                        Hủy
                    </Button>
                </div>

            </Form>
        </Modal>
    );
}